/**
 * Extracts the video id from youtube.com/watch (v= anywhere in the query),
 * youtu.be/, /embed/ and /shorts/ URLs.
 *
 * Mirrored by the editor-facing validation in
 * sanity/schemaTypes/landingComponents/videoPlaceholder.ts (the studio is a
 * separate package, so it cannot import this module); keep the two in step.
 */
export const YOUTUBE_ID_PATTERN =
  /(?:youtube\.com\/(?:watch\?(?:[^#]*&)?v=|embed\/|shorts\/)|youtu\.be\/)([\w-]{11})/;

export const getYoutubeId = (url?: string): string | null => {
  if (!url) return null;
  const match = url.match(YOUTUBE_ID_PATTERN);
  return match ? match[1] : null;
};
